import React from 'react';

import { Dialog } from 'wix-ui-tpa/cssVars';
import { ButtonNames } from '../../contexts/main/biInterfaces';
import { useEnvironment, useBi, useTranslation } from '@wix/yoshi-flow-editor';
import { memberWebAppButtonClick as memberWebAppButtonClickV2 } from '@wix/bi-logger-challenges-member-web/v2';
import { FCWithChildren } from '@wix/challenges-web-library';

import { st, classes } from './Modal.st.css';

export interface IModalProps {
  opened?: boolean;
  onClose(): void;
  className?: string;
  contentClassName?: string;
  sticky?: boolean;
  closeAriaLabel?: string;
  isRTL?: boolean;
  dataHook?: string;
  dialogClassName?: string;
}

export const Modal: FCWithChildren<IModalProps> = (props) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { className, sticky = false, contentClassName } = props;

  const bi = useBi();

  const handleClose = () => {
    bi.report(
      memberWebAppButtonClickV2({
        buttonName: ButtonNames.CloseModalButton,
      }),
    );

    props.onClose();
  };

  const modalContent = (
    <div data-hook={props.dataHook}>
      <section
        className={st(
          classes.root,
          {
            mobile: isMobile,
            sticky,
            bottomRelated: isMobile,
            isRTL: props.isRTL,
          },
          className,
        )}
      >
        <div className={`${classes.content} ${contentClassName || ''}`}>
          {props.children}
        </div>
      </section>
    </div>
  );

  return (
    <Dialog
      isOpen={props.opened}
      onClose={handleClose}
      className={props.dialogClassName}
      closeButtonAriaLabel={t('modals.close-label')}
    >
      {modalContent}
    </Dialog>
  );
};
